import React from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Helmet } from "react-helmet";
import Container from "react-bootstrap/Container";

import PlaylistRecentGrid from "./PlaylistRecentGrid";

const PlaylistRecentPage = ({ match }) => {
  return (
    <div className="playlist-page">
      <Helmet>
        <title>Recent Playlist | Dream Chimney</title>
        <link rel="canonical" href={`https://www.dreamchimney.com/tracks/playlists/recent`} />
      </Helmet>
      <Container fluid>
        <Row>
          <Col xs={12}>
            <h2 className="page-header">Recent Playlists</h2>
            <p>Explore some recently created playlists</p>
          </Col>
        </Row>

        <Row style={{ marginTop: 20, marginBottom: 40 }}>
          <PlaylistRecentGrid limit={12} />
        </Row>
      </Container>
    </div>
  );
};

export default PlaylistRecentPage;
